export const userProfile = {
  user_alias: "昵称",
  user_name: "名字",
  user_lastName: "姓氏",
  user_email: "电子邮件",
  user_phoneNumber: "电话号码",
  user_birthdate: "出生日期",
  user_national_id: "身份证",
  user_state: "省份",
  user_city: "城市",
  user_support_message: "要对您的个人资料进行任何更改或更新，请联系我们的",
  user_support_link: "技术支持",

  userProfileImageFormat: "不支持的格式",
  userProfileImageFormatDesc: "只允许JPEG、JPG或PNG格式的图片。",
  userProfileImageSize: "图片太大",
  userProfileImageSizeDesc: "允许的最大大小为3MB。",
  userProfileImageEdit: "编辑",
};
